var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21078_20045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6767 31.8416V15.442L5.56424 10.7891L0.979736 8.20703V28.9475C0.979736 30.5488 2.2839 31.8416 3.8889 31.8416H10.6767Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9495 31.8414H40.7373C42.3471 31.8414 43.6465 30.5439 43.6465 28.9473V8.20703L38.4538 11.1645L33.9495 15.4418V31.8414Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6764 15.443L9.98071 9.03523L10.6764 2.90234L22.3127 11.5845L33.949 2.90234L34.7272 8.70413L33.949 15.443L22.3127 24.1251L10.6764 15.443Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9495 2.90217V15.4429L43.6465 8.20787V4.34913C43.6465 0.77027 39.5398 -1.26994 36.6648 0.876384L33.9495 2.90217Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.979736 8.20794L5.43957 11.5356L10.6767 15.4429V2.90224L7.9614 0.87646C5.0814 -1.27003 0.979736 0.770346 0.979736 4.34904V8.20794Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21078_20045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 32,
    fill: "white",
    transform: "translate(0.979736)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.1be87cf22181a3f440588528c4d5f68d.svg";
export { ForwardRef as ReactComponent };